/**
 * animation constants
 */
export const ANIMATION_TIMEOUT_APPEAR = 300;
export const ANIMATION_TIMEOUT_INOUT = 500;
export const ANIMATION_TIMEOUT_MODAL = 0.3;
